<template>
  <div class="">
    <sub-tab :currentTab="tab" :subTab="subTab"></sub-tab>
    <top v-if="tab === 'top'" :currentTab="tab"></top>
    <inventory-inquiry v-if="tab === 'inventory' && subTab === 'inventory-inquiry'"></inventory-inquiry>
    <inventory-end-of-month v-if="tab === 'inventory' && subTab === 'inventory-end-of-month'"></inventory-end-of-month>
    <delivery-status-inquiry v-if="tab === 'delivery' && subTab === 'delivery-status-inquiry'"></delivery-status-inquiry>
    <direct-delivery v-if="tab === 'delivery' && subTab === 'direct-delivery'"></direct-delivery>
    <shipping-cost v-if="tab === 'expense-details' && subTab === 'shipment-record'"></shipping-cost>
    <other-cost v-if="tab === 'expense-details' && subTab === 'storage-fees'"></other-cost>
    <setting-across-price-diff v-if="tab === 'settings' && subTab === 'price-diff'"></setting-across-price-diff>
    <shipping-list v-if="tab === 'shipping' && subTab === 'shipping-status-inquiry'"></shipping-list>
    <amazon-shipping v-if="tab === 'shipping' && subTab === 'amazon-shipping'"></amazon-shipping>
    <multi-channel-shipping v-if="tab === 'shipping' && subTab === 'multi-channel'"></multi-channel-shipping>
  </div>
</template>
<script>
import Top from './Top'
import InventoryInquiry from './InventoryInquiry'
import InventoryEndOfMonth from './InventoryEndOfMonth'
import DeliveryStatusInquiry from './DeliveryStatusInquiry'
import DirectDelivery from './DirectDelivery'
import ShippingCost from './ShippingCost'
import OtherCost from './OtherCost'
import SettingAcrossPriceDiff from './SettingAcrossPriceDiff'
import SubTab from './Subtab'
import ShippingList from './ShippingStatusInquiry'
import MultiChannelShipping from './MultiChannelShipping'
import AmazonShipping from './AmazonShipping'
export default {
  data () {
    return {
    }
  },
  components: {
    SubTab,
    Top,
    InventoryInquiry,
    InventoryEndOfMonth,
    DeliveryStatusInquiry,
    DirectDelivery,
    ShippingCost,
    OtherCost,
    SettingAcrossPriceDiff,
    ShippingList,
    MultiChannelShipping,
    AmazonShipping
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    },
    subTab: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.tab-content {
  padding: 10px;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/TabContent.vue